import LoyallistImage from '@core/csg/src/assets/images/bcom/compressed/loyalty-bloom-loyallist-small.svg';
import LoyallistTopImage from '@core/csg/src/assets/images/bcom/compressed/loyalty-bloom-top-of-the-list-small.svg';
import LoyallistKeyImage from '@core/csg/src/assets/images/bcom/compressed/loyalty-bloom-tol-unlocked-small.svg';
import LoyaltyBronze from '@core/csg/src/assets/images/mcom/compressed/loyalty-macys-bronze-large.svg';
import LoyaltyPlatinum from '@core/csg/src/assets/images/mcom/compressed/loyalty-macys-platinum-large.svg';
import LoyaltyGold from '@core/csg/src/assets/images/mcom/compressed/loyalty-macys-gold-large.svg';
import LoyaltySilver from '@core/csg/src/assets/images/mcom/compressed/loyalty-macys-silver-large.svg';

export const PPC_DATA = Symbol.for('PPC_DATA');

export const LOYALTY_3PC_OFFER_NAMES = {
  multiplier: 'MULTIPLIER',
  pointsPerDollar: 'PULSE',
  powerPoints: 'FIXED',
} as const;

export const LOYALTY_TIER_DETAILS = {
  base: {
    icon: LoyallistImage,
    membershipDetails: {
      membership: 'Loyallists',
    },
  },
  tol: {
    icon: LoyallistTopImage,
    membershipDetails: {
      membership: 'Top of the List',
    },
  },
  unl: {
    icon: LoyallistKeyImage,
    membershipDetails: {
      membership: 'Top of the List Unlocked',
    },
  },
  bronze: {
    icon: LoyaltyBronze,
    membershipDetails: {},
  },
  silver: {
    icon: LoyaltySilver,
    membershipDetails: {},
  },
  gold: {
    icon: LoyaltyGold,
    membershipDetails: {},
  },
  platinum: {
    icon: LoyaltyPlatinum,
    membershipDetails: {},
  },
} as const;

const DEFAULT_LOYALTY_COPY = {
  tags: ['[$AWARDED_POINTS]'],
  includeDetails: false,
};

export const LOYALTY_COPIES = [
  {
    type: 'base',
    copy: 'Earn <span class="loyalty-text--total-points">[$AWARDED_POINTS] points</span> with this purchase.',
    perksCopy: 'Earn [$AWARDED_POINTS] points with this purchase.',
    ...DEFAULT_LOYALTY_COPY,
  },
  {
    type: 'multiplier',
    baseCopy: 'Earn [$MULTIPLIER]X points with purchase',
    copy: '(that’s <span class="loyalty-text--total-points">[$AWARDED_POINTS] points</span>)!',
    perksCopy: '(that’s [$AWARDED_POINTS] points)!',
    tags: ['[$MULTIPLIER]', '[$AWARDED_POINTS]'],
    includeDetails: false,
  },
  {
    type: 'pointsPerDollar',
    baseCopy: 'Earn an extra [$PULSE] points per dollar',
    copy: '(that’s <span class="loyalty-text--total-points">[$AWARDED_POINTS] points</span>)!',
    perksCopy: '(that’s [$AWARDED_POINTS] points)!',
    tags: ['[$PULSE]', '[$AWARDED_POINTS]'],
    includeDetails: false,
  },
  {
    type: 'powerPoints',
    copy: 'Power Points offer: Earn <span class="loyalty-text--total-points">[$AWARDED_POINTS] points</span> with this purchase.',
    perksCopy: 'Power Points offer: Earn [$AWARDED_POINTS] points with this purchase.',
    ...DEFAULT_LOYALTY_COPY,
  },
] as const;

export const BASE_LOYALTY_TIER_ICON = LOYALTY_TIER_DETAILS.base.icon;
